(function initializeNearpeerBootLoader() {
    window.__nearpeerLoadingScreenStartedAt = window.performance && window.performance.now
        ? window.performance.now()
        : Date.now();

    var arc = document.getElementById('nearpeer-loading-screen-loader-arc');
    var duration = 900;
    var start = window.__nearpeerLoadingScreenStartedAt;
    var frameId = null;
    var dismissed = false;
    var now = function now() {
        return window.performance && window.performance.now
            ? window.performance.now()
            : Date.now();
    };
    var isCordovaLike = function isCordovaLike() {
        var userAgent = window.navigator && window.navigator.userAgent || '';

        return !!window.cordova || (/Android/i.test(userAgent) && /; wv\)/i.test(userAgent));
    };

    if (typeof start !== 'number') {
        start = now();
        window.__nearpeerLoadingScreenStartedAt = start;
    }

    var setFrame = function setFrame() {
        if (!arc) {
            return;
        }

        var elapsed = now() - start;
        var phase = (elapsed % duration) / duration;
        var angle = (phase * 360) - 90;

        arc.setAttribute('transform', 'rotate(' + angle + ' 50 50)');
    };

    var tick = function tick() {
        setFrame();

        if (!dismissed) {
            frameId = window.requestAnimationFrame(tick);
        }
    };

    window.__nearpeerSetBootLoaderMessage = function setNearpeerBootLoaderMessage(message) {
        var text = document.getElementById('nearpeer-boot-loader-text');
        var loader = document.getElementById('nearpeer-boot-loader');

        if (!text || !loader || !message) {
            return;
        }

        text.textContent = message;
        loader.setAttribute('aria-label', message);
    };

    window.__nearpeerDismissBootLoader = function dismissNearpeerBootLoader() {
        var loader = document.getElementById('nearpeer-boot-loader');

        if (!loader || dismissed) {
            return;
        }

        dismissed = true;

        if (frameId) {
            window.cancelAnimationFrame(frameId);
        }

        loader.parentNode.removeChild(loader);
    };

    if (arc && isCordovaLike()) {
        arc.style.animation = 'none';
        arc.style.webkitAnimation = 'none';
        setFrame();
        frameId = window.requestAnimationFrame(tick);
    }
}());
